import PropTypes from 'prop-types';
import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';
import { toast } from '@hivebrite/design-system/Toast';

import LoginWrapper from 'hb-react/frontoffice/components/LoginWrapper';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import ExclamationMark from 'hb-react/shared/icons/ExclamationMark';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const RsvpDropdown = ({
  defaultValue,
  endDate,
  eventId,
  eventType,
  onSave,
  options,
  reachedMaxCapacity,
}) => {
  const { currentUser } = useDefaultAppContexts();
  const [selected, setSelected] = useState(
    getReactSelectValue(options, defaultValue),
  );

  if (!currentUser) {
    return (
      <Box alignItems="center">
        <Box font="body-semibold-asphalt" fontWeight={700} mr={3}>
          {I18n.t('js.event.are_you_going')}
        </Box>
        <LoginWrapper />
      </Box>
    );
  }

  const today = new Date();

  if (endDate < today) {
    return null;
  }

  const updateAnswer = (newAnswer) => {
    setSelected(newAnswer);
    const userId = currentUser.id;

    const attendRoute = Routes.attend_user_network_event_responses_path;
    const maybeAttendRoute =
      Routes.maybe_attend_user_network_event_responses_path;
    const cancelRoute = Routes.cancel_user_network_event_responses_path;

    const routes = {
      network_events_event: {
        attend: attendRoute(userId, eventId),
        maybe_attend: maybeAttendRoute(userId, eventId),
        cancel: cancelRoute(userId, eventId),
      },
      event: {
        attend: Routes.attend_user_event_path(userId, eventId),
        maybe_attend: Routes.maybe_attend_user_event_path(userId, eventId),
        cancel: Routes.cancel_user_event_path(userId, eventId),
      },
    };

    axios
      .put(routes[eventType][newAnswer.value])
      .then((response) => {
        toast.success(
          I18n.t(`web.events.participation_msg.${newAnswer.value}_message`),
        );
        onSave && onSave(response.data.event, newAnswer.value);
      })
      .catch(() => {
        toast.error(
          I18n.t(`web.events.participation_msg.${newAnswer.value}_error`),
        );
      });
  };

  return (
    <Box flexDirection="column">
      <ReactSelectInput
        id="rsvp_answer"
        name="rsvp_answer"
        label={I18n.t('js.event.are_you_going')}
        options={options}
        onChange={updateAnswer}
        value={selected}
        placeholder={__('Not responded')}
        disabled={reachedMaxCapacity}
      />
      {reachedMaxCapacity && (
        <Box fontStyle="italic" alignItems="center" pt={1}>
          <ExclamationMark width="25px" height="25px" />
          <Box font="body-regular-dove">
            {s__('Events|This event has reached capacity')}
          </Box>
        </Box>
      )}
    </Box>
  );
};

RsvpDropdown.propTypes = {
  defaultValue: PropTypes.string,
  eventId: PropTypes.number.isRequired,
  eventType: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  onSave: PropTypes.func,
  reachedMaxCapacity: PropTypes.bool,
};

export default RsvpDropdown;
